import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { decorateUrlWithItm } from 'utils/itm';

import ArrowRightIcon from '@tradera/tradera-ui/icons/arrow-right.svg?jsx';

const MenuItem = ({
    imageUrl,
    icon,
    label,
    link,
    cssClass,
    notify,
    showArrow,
    border,
    bold,
    itm,
    follow,
    onClick
}) => {
    const InnerHtml = (
        <Fragment>
            {icon && (
                <span
                    className="site-dropdown__item__image d-flex align-items-center justify-content-center"
                    style={{ backgroundImage: imageUrl }}>
                    {icon}
                </span>
            )}
            <span
                className={`flex-grow pl-3 ${bold ? 'font-weight-bold' : ''}`}>
                {label}
            </span>
            <span className="d-flex ml-auto">
                {notify > 0 && (
                    <span className=" mr-3 site-dropdown__notification">
                        {notify}
                    </span>
                )}
                <span className="mr-3 site-dropdown__item__arrow">
                    {showArrow && <ArrowRightIcon className="icon" />}
                </span>
            </span>
        </Fragment>
    );

    const containerClass = `site-dropdown__item d-flex flex-row align-items-center ${
        cssClass ? cssClass : ''
    } ${border ? 'border-bottom' : ''}`;

    return (
        <li>
            {!onClick ? (
                <a
                    className={containerClass}
                    href={itm ? decorateUrlWithItm(link, itm) : link}
                    {...!follow && { rel: 'nofollow' }}>
                    {InnerHtml}
                </a>
            ) : (
                <span className={containerClass} onClick={onClick}>
                    {InnerHtml}
                </span>
            )}
        </li>
    );
};

MenuItem.defaultProps = {
    cssClass: 'site-dropdown__item-default',
    notify: 0,
    bold: false,
    border: false,
    follow: true
};

MenuItem.propTypes = {
    notify: PropTypes.number,
    link: PropTypes.string,
    bold: PropTypes.bool,
    border: PropTypes.bool,
    label: PropTypes.node
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/dropdown-menu-item.jsx